import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResultVheiclePart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 88,
	height: 72,
	viewBox: "0 0 88 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.8,
			cy: 54.8,
			r: 2.8,
			fill: "#F5F4F4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 62,
			r: 2,
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 70,
			cy: 2,
			r: 2,
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 85.1984,
			cy: 6.8,
			r: 2.8,
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 41,
			cy: 36,
			r: 36,
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.6141 19.0508H27.4391C22.7891 19.0508 21.7391 21.3758 21.1641 24.2508L19.0391 34.3758H49.0391L46.9141 24.2508C46.2891 21.3758 45.2641 19.0508 40.6141 19.0508Z",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.738 50.9016C52.938 53.1016 51.188 55.0016 48.938 55.0016H45.413C43.388 55.0016 43.113 54.1265 42.738 53.0765L42.363 51.9517C41.838 50.4267 41.488 49.3766 38.788 49.3766H29.188C26.488 49.3766 26.088 50.5517 25.613 51.9517L25.238 53.0765C24.888 54.1515 24.613 55.0016 22.563 55.0016H19.038C16.788 55.0016 15.013 53.1016 15.238 50.9016L16.288 39.4765C16.563 36.6515 17.088 34.3516 22.013 34.3516H45.938C50.863 34.3516 51.388 36.6515 51.663 39.4765L52.738 50.9016Z",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0156 28.75H17.1406",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.8906 28.75H49.0156",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7656 41.875H28.3906",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.6406 41.875H45.2656",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2656 13.2174L44.6656 8L48.1656 13.2174L52.3656 9.95652L51.6656 15.1739L55.8656 15.8261L52.3656 19.7391L57.2656 21.0435L53.7656 23",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.3698 64.9284L70.0292 57.5877L77.3698 64.9284ZM70.0292 57.5877C71.2848 56.3321 72.2808 54.8414 72.9604 53.2008C73.64 51.5602 73.9897 49.8019 73.9897 48.0261C73.9897 46.2503 73.64 44.492 72.9604 42.8514C72.2808 41.2108 71.2848 39.7201 70.0292 38.4645C68.7735 37.2088 67.2828 36.2128 65.6422 35.5332C64.0016 34.8537 62.2433 34.5039 60.4675 34.5039C58.6918 34.5039 56.9334 34.8537 55.2928 35.5332C53.6522 36.2128 52.1615 37.2088 50.9059 38.4645C48.37 41.0004 46.9453 44.4398 46.9453 48.0261C46.9453 51.6124 48.37 55.0518 50.9059 57.5877C53.4418 60.1237 56.8812 61.5483 60.4675 61.5483C64.0538 61.5483 67.4932 60.1237 70.0292 57.5877Z",
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.3698 64.9284L70.0292 57.5877M70.0292 57.5877C71.2848 56.3321 72.2808 54.8414 72.9604 53.2008C73.64 51.5602 73.9897 49.8019 73.9897 48.0261C73.9897 46.2503 73.64 44.492 72.9604 42.8514C72.2808 41.2108 71.2848 39.7201 70.0292 38.4645C68.7735 37.2088 67.2828 36.2128 65.6422 35.5332C64.0016 34.8537 62.2433 34.5039 60.4675 34.5039C58.6918 34.5039 56.9334 34.8537 55.2928 35.5332C53.6522 36.2128 52.1615 37.2088 50.9059 38.4645C48.37 41.0004 46.9453 44.4398 46.9453 48.0261C46.9453 51.6124 48.37 55.0518 50.9059 57.5877C53.4418 60.1237 56.8812 61.5483 60.4675 61.5483C64.0538 61.5483 67.4932 60.1237 70.0292 57.5877Z",
			stroke: "#A0A0A0",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.6105 48.0559C70.6043 50.0623 70.003 52.0218 68.8828 53.6864C67.7625 55.351 66.1738 56.6459 64.3174 57.4072C62.461 58.1685 60.4205 58.3621 58.4541 57.9633C56.4877 57.5646 54.6838 56.5916 53.2706 55.1673C51.8574 53.743 50.8984 51.9315 50.515 49.962C50.1316 47.9925 50.341 45.9537 51.1168 44.1032C51.8925 42.2528 53.1997 40.6741 54.8729 39.5669C56.5462 38.4596 58.5103 37.8736 60.5167 37.8829C61.8491 37.8821 63.1685 38.1452 64.3987 38.6572C65.6289 39.1691 66.7454 39.9196 67.6839 40.8655C68.6224 41.8113 69.3643 42.9337 69.8666 44.1679C70.3689 45.402 70.6217 46.7234 70.6105 48.0559ZM68.9443 48.0441C68.9463 46.3684 68.4516 44.7297 67.523 43.335C66.5943 41.9402 65.2732 40.8519 63.7265 40.2074C62.1797 39.5629 60.4767 39.3912 58.8324 39.7139C57.1882 40.0366 55.6764 40.8393 54.488 42.0206C53.2995 43.2019 52.4878 44.7088 52.1552 46.3511C51.8225 47.9934 51.984 49.6975 52.6191 51.2481C53.2542 52.7987 54.3345 54.1264 55.7236 55.0635C57.1127 56.0006 58.7484 56.5051 60.424 56.5133C61.5432 56.5299 62.6543 56.3225 63.6922 55.9034C64.7301 55.4843 65.6737 54.8619 66.4675 54.0728C67.2614 53.2837 67.8895 52.3439 68.3148 51.3086C68.7402 50.2733 68.9542 49.1633 68.9443 48.0441Z",
			fill: "#646464"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.1594 42.0661C62.1594 42.5461 61.7314 42.8751 61.0014 42.8904C59.9789 42.9178 58.9821 43.1741 58.1077 43.6343C57.7333 43.8371 57.3824 44.0709 57.06 44.3323C56.524 44.7435 56.0168 44.7473 55.6286 44.3629C55.542 44.2758 55.4774 44.174 55.4391 44.064C55.4007 43.9539 55.3893 43.8382 55.4057 43.7241C55.4222 43.6101 55.466 43.5002 55.5344 43.4017C55.6028 43.3033 55.6942 43.2183 55.8028 43.1523C57.2251 41.9615 59.1192 41.2882 61.0962 41.2706C61.2272 41.2581 61.3597 41.2692 61.4855 41.3031C61.6113 41.3371 61.7277 41.3931 61.8275 41.4677C61.9272 41.5424 62.0081 41.634 62.0652 41.7369C62.1223 41.8399 62.1544 41.952 62.1594 42.0661Z",
			fill: "#646464"
		})
	]
});
export default SvgNoResultVheiclePart;
